export default {
  getHead: () => {
    return [{name: '학교명'}, {name: '작성자'}, {name: '작성일'}, {name: '산업안전보건관리비 예산'}, {name: '산업안전보건관리비 집행율'}, {name: '안전관리비 예산'}, {name: '안전관리비 집행율'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).inputA_1
      case 1: return func.getContent(value).stdInfo.writer_name
      case 2: return func.getCreatedDate(value.created_at) // 작성일
      case 3: {
        let sum1 = 0
        for (const data of func.getContent(value).inputB) {
          sum1 += Number(data.value1)
        }
        return func.comma(sum1)
      }
      case 4: {
        let sum1 = 0
        let sum2 = 0
        for (const data of func.getContent(value).inputB) {
          sum1 += Number(data.value1)
          sum2 += Number(data.value2)
        }
        return Math.floor(sum2 * 10000.0 / sum1) / 100
      }
      case 5: {
        let sum1 = 0
        for (const data of func.getContent(value).inputC) {
          sum1 += Number(data.value1)
        }
        return func.comma(sum1)
      }
      case 6: {
        let sum1 = 0
        let sum2 = 0
        for (const data of func.getContent(value).inputC) {
          sum1 += Number(data.value1)
          sum2 += Number(data.value2)
        }
        return Math.floor(sum2 * 10000.0 / sum1) / 100
      }
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    return {}
  },
  getSearchKeyword: (nav) => {
    return []
  },
}
